import React from 'react';

export default function TextBold({ children }) {
  return <div style={{ fontSize: '1.25em' }} class='font-bold font-[NotoSansKR]'>{children}</div>;
}
